import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from './firebase/config';
import Login from './pages/Login';
import Home from './pages/Home';
import Session from './pages/Session';

// ── AuthGate — espera a saber si hay usuario antes de renderizar ──────────────

const AuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => {
      setUser(u);
      setChecked(true);
    });
    return unsub;
  }, []);

  if (!checked) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f2ec', fontFamily: "'DM Mono',monospace", color: '#aaa' }}>
      …
    </div>
  );

  if (!user) return <Login />;
  return <>{children}</>;
};

// ── App ───────────────────────────────────────────────────────────────────────

const App: React.FC = () => (
  <BrowserRouter>
    <Routes>
      {/* Login — accesible sin auth */}
      <Route path="/login" element={<Login />} />

      {/* Home — requiere auth */}
      <Route path="/" element={
        <AuthGate><Home /></AuthGate>
      } />

      {/* Sesión activa — requiere auth */}
      <Route path="/session/:sessionId" element={
        <AuthGate><Session /></AuthGate>
      } />

      {/* Cualquier otra ruta → home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);

export default App;